import accounting from 'accounting';
window.accounting = accounting;